import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useState} from "../_snowpack/pkg/react.js";
import {
  getEditorUrl,
  getPageProduct,
  withAttrs
} from "../common/utils.js";
import {useProductStore} from "../stores/product.js";
import ProcessNavi from "./process-navi.js";
import {t} from "../common/i18n.js";
import {colors, fontFamily, gap, lineHeight, media, shadow} from "./theme.js";
import Stack from "./stack.js";
import Input from "./input.js";
import Inline from "./inline.js";
import ProductQuantitySlider from "./product-quantity-slider.js";
import Image from "./image.js";
import Button from "./button.js";
import ProductPriceOverview from "./product-price-overview.js";
import {Text} from "./typo.js";
export default function ProductStepsConfig(props) {
  const [store, setStore] = useProductStore();
  const {
    product,
    config,
    quantity,
    article,
    cartItem,
    priceResponse,
    optionsResponse,
    disabledValues: storeDisabledValues = {},
    configDefs: storeConfigDef
  } = store;
  const {page} = product;
  const pageProduct = getPageProduct(page);
  if (pageProduct.component === "model_product")
    return null;
  if (pageProduct.component === "standard_product")
    return null;
  const {config: productConfig} = pageProduct;
  const initialConfigValues = {...config, quantity};
  const initialRegeneratedOptions = {
    configValues: initialConfigValues,
    configDefs: storeConfigDef || productConfig,
    disabledValues: storeDisabledValues
  };
  const {value: prices, error: priceError} = priceResponse;
  const setConfigValues = (c) => {
    setStore((s) => {
      const {quantity: quantity2 = s.quantity, ...rest} = c;
      return {
        ...s,
        disabledValues,
        configDefs,
        quantity: quantity2,
        config: {
          ...s.config,
          ...rest
        }
      };
    });
  };
  const {value: regeratedOptions, error: optionsError} = optionsResponse;
  const {configValues, configDefs, disabledValues} = regeratedOptions || initialRegeneratedOptions;
  const onChange = (c) => setConfigValues(c);
  const editorUrl = getEditorUrl(page, {
    quantity,
    article_id: article.id,
    item_id: cartItem?.id,
    product_config: config
  });
  return /* @__PURE__ */ React.createElement(Steps, {
    configValues,
    configDefs,
    disabledValues,
    editorUrl,
    onChange,
    error: optionsError || priceError,
    prices,
    ...props
  });
}
function Steps(props) {
  const {
    configValues,
    configDefs,
    disabledValues,
    editorUrl,
    onChange,
    prices,
    error,
    ...rest
  } = props;
  const [activeStep, setActiveStep] = useState(0);
  const lastStep = activeStep >= configDefs.length - 1;
  const naviSteps = configDefs.map((g) => {
    if (g.component === "size_config") {
      return {text: t("Größe & Menge")};
    }
    if (g.component === "options_config") {
      return {text: g.label};
    }
    return {text: g.headline};
  });
  const onClickNext = () => setActiveStep(activeStep + 1);
  const onStepClick = (n) => setActiveStep(n);
  const orderDisabled = !!error || !prices;
  return /* @__PURE__ */ React.createElement(StepsContainer, {
    ...rest
  }, /* @__PURE__ */ React.createElement(ProcessNavi, {
    steps: naviSteps,
    activeStep,
    onStepClick
  }), /* @__PURE__ */ React.createElement(StepsWindow, null, /* @__PURE__ */ React.createElement(StepsSlider, {
    style: {"--activeStep": activeStep}
  }, configDefs.map((s, i) => /* @__PURE__ */ React.createElement(Step, {
    key: s._uid,
    configValues,
    configDef: s,
    disabledValues,
    onChange,
    active: activeStep === i,
    index: i,
    errors: error?.errors
  })))), /* @__PURE__ */ React.createElement(PriceContainer, null, /* @__PURE__ */ React.createElement(ProductPriceOverview, {
    ...prices,
    stepConfig: true
  })), /* @__PURE__ */ React.createElement(StepsFooter, null, lastStep ? /* @__PURE__ */ React.createElement(StepsButton, {
    href: editorUrl,
    disabled: orderDisabled
  }, t("Produkt gestalten")) : /* @__PURE__ */ React.createElement(StepsButton, {
    onClick: onClickNext
  }, t("Weiter"))));
}
function Step(props) {
  const {configDef, ...rest} = props;
  if (configDef.component === "size_config") {
    return /* @__PURE__ */ React.createElement(SizeStep, {
      configDef,
      ...rest
    });
  }
  if (configDef.component === "group_config") {
    return /* @__PURE__ */ React.createElement(GroupStep, {
      configDef,
      ...rest
    });
  }
  if (configDef.component === "options_config") {
    return /* @__PURE__ */ React.createElement(OptionsStep, {
      configDef,
      ...rest
    });
  }
  return null;
}
function OptionsStep(props) {
  const {configDef, configValues, disabledValues, onChange, ...rest} = props;
  const {options, key, label} = configDef;
  const value = configValues[key];
  const disabledOptions = disabledValues[key];
  const onOptionChange = (v) => onChange({[key]: v});
  return /* @__PURE__ */ React.createElement(StepContainer, {
    ...rest
  }, /* @__PURE__ */ React.createElement(StepSection, null, /* @__PURE__ */ React.createElement(StepSectionHeadline, null, label), /* @__PURE__ */ React.createElement(StepSectionOptions, {
    options,
    value,
    disabledOptions,
    onChange: onOptionChange
  })));
}
function GroupStep(props) {
  const {configDef, configValues, disabledValues, onChange, errors, ...rest} = props;
  const {options} = configDef;
  return /* @__PURE__ */ React.createElement(StepContainer, {
    ...rest
  }, options.map((o) => /* @__PURE__ */ React.createElement(GroupStepSection, {
    key: o._uid,
    optionConfig: o,
    configValues,
    disabledValues,
    onChange,
    errors
  })));
}
function GroupStepSection(props) {
  const {optionConfig, configValues, disabledValues, onChange, errors} = props;
  const {label, options, key} = optionConfig;
  const error = errors ? errors[key] : void 0;
  const onOptionChange = (v) => onChange({[key]: v});
  return /* @__PURE__ */ React.createElement(StepSection, null, /* @__PURE__ */ React.createElement(StepSectionHeadline, null, label), /* @__PURE__ */ React.createElement(StepSectionOptions, {
    options,
    value: configValues[key],
    disabledOptions: disabledValues[key],
    onChange: onOptionChange,
    error,
    twoColumns: key === "finishing"
  }));
}
function StepSectionOptions(props) {
  const {
    options,
    value,
    disabledOptions,
    onChange,
    error,
    twoColumns = false
  } = props;
  return /* @__PURE__ */ React.createElement(StepSectionOptionsContainer, null, /* @__PURE__ */ React.createElement(StepSectionOptionsInner, {
    twoColumns
  }, options.map((o) => /* @__PURE__ */ React.createElement(StepOption, {
    key: o._uid,
    active: o.value === value,
    disabled: disabledOptions && disabledOptions.includes(o.value),
    ...o,
    onClick: () => onChange(o.value)
  }))), error && /* @__PURE__ */ React.createElement(StepFieldError, null, error.message));
}
function StepOption(props) {
  const {image, text, description, active, disabled, ...rest} = props;
  const hasImage = image && !!image.filename;
  return /* @__PURE__ */ React.createElement(StepOptionContainer, {
    active,
    disabled,
    hasImage,
    ...rest
  }, hasImage && /* @__PURE__ */ React.createElement(StepOptionImage, {
    ...image
  }), /* @__PURE__ */ React.createElement("div", null, text && /* @__PURE__ */ React.createElement(StepOptionText, null, text), description && /* @__PURE__ */ React.createElement(StepOptionDescription, null, description)));
}
function SizeStep(props) {
  const {configValues, configDef, onChange, errors, ...rest} = props;
  const {dimensions, image} = configDef;
  return /* @__PURE__ */ React.createElement(StepContainer, {
    ...rest
  }, /* @__PURE__ */ React.createElement(StepSection, null, /* @__PURE__ */ React.createElement(StepSectionSizeGrid, null, /* @__PURE__ */ React.createElement(StepSectionSizeGridCell, null, /* @__PURE__ */ React.createElement(StepSectionHeadline, null, t("Größe")), /* @__PURE__ */ React.createElement(StepSectionFields, null, dimensions.map((d) => /* @__PURE__ */ React.createElement(StepSizeField, {
    key: d._uid,
    configDef: d,
    configValues,
    onChange,
    error: errors ? errors[d.key] : void 0
  })))), image && /* @__PURE__ */ React.createElement(StepSectionSizeImage, {
    ...image
  }))), /* @__PURE__ */ React.createElement(StepSection, null, /* @__PURE__ */ React.createElement(StepSectionHeadline, null, t("Auflage")), /* @__PURE__ */ React.createElement(StepQuantitySlider, {
    onChange
  })));
}
function StepQuantitySlider(props) {
  const {onChange} = props;
  const [store] = useProductStore();
  const {quantity, min, max, step} = store;
  const onSliderChange = (n) => {
    onChange({quantity: n});
  };
  return /* @__PURE__ */ React.createElement(StepSlider, {
    value: quantity,
    min,
    max,
    step,
    onChange: onSliderChange
  });
}
function StepSizeField(props) {
  const {configValues, configDef, onChange, error} = props;
  const {key, label, unit, default_value} = configDef;
  const value = configValues[key] ?? default_value;
  const hasError = !!error;
  const onInputChange = (e) => {
    const {value: value2} = e.target;
    if (!value2)
      return;
    onChange({[key]: parseInt(value2)});
  };
  return /* @__PURE__ */ React.createElement(FieldContainer, null, /* @__PURE__ */ React.createElement(FieldInner, null, /* @__PURE__ */ React.createElement(FieldLabel, null, label), /* @__PURE__ */ React.createElement(FieldInput, {
    type: "number",
    name: key,
    value,
    min: 0,
    step: 1,
    onChange: onInputChange,
    invalid: hasError
  }), /* @__PURE__ */ React.createElement(FieldText, null, unit)), error && /* @__PURE__ */ React.createElement(StepFieldError, null, error?.message));
}
function sameObj(a, b) {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length)
    return false;
  const aKeysSet = new Set(aKeys);
  const sameKeys = !bKeys.some((k) => !aKeysSet.has(k));
  if (!sameKeys)
    return false;
  return !aKeys.some((k) => !Object.is(a[k], b[k]));
}
const StepsContainer = styled(withAttrs(Stack, {spacing: "xl"}))`
  padding: 24px;
  box-shadow: ${shadow.card};
  border-radius: 4px;
`;
const StepsWindow = styled.div`
  overflow: hidden;
`;
const StepsSlider = styled.div`
  display: flex;
  align-items: center;
  flex-direction: columns;
  flex-wrap: nowrap;
  transform: translate(calc(var(--activeStep) * -100%));
  transition: transform 0.3s;
`;
const StepContainer = styled(withAttrs(Stack, {spacing: "xl"}))`
  width: 100%;
  flex-shrink: 0;
  position: absolute;

  ${({index}) => `left: ${index * 100}%;`}
  ${({active}) => active && `position: relative;`}
`;
const StepSection = styled.div``;
const StepSectionHeadline = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 24px;

  ${media.mobile} {
    font-size: 18px;
    margin-bottom: 22px;
  }
`;
const StepSectionSizeGrid = styled.div`
  display: flex;
`;
const StepSectionSizeGridCell = styled.div``;
const StepSectionSizeImage = styled(Image)`
  margin-left: auto;
  margin-right: auto;
  max-height: 100%;
  max-width: 100%;
  width: auto;
  object-fit: contain;

  ${media.phone} {
    display: none;
  }
`;
const StepSectionFields = styled(Stack)``;
const FieldContainer = styled(withAttrs(Stack, {spacing: "xs"}))``;
const FieldInner = styled(Inline)``;
const FieldText = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`;
const FieldLabel = styled(FieldText)`
  width: 64px;
`;
const FieldInput = styled(withAttrs(Input, {small: true}))`
  width: 100px;
`;
const StepSlider = styled(ProductQuantitySlider)`
  width: 264px;
`;
const StepSectionOptionsContainer = styled(withAttrs(Stack, {spacing: "xs"}))``;
const StepSectionOptionsInner = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;

  ${({twoColumns}) => twoColumns && `grid-template-columns: repeat(2, 1fr);`}

  ${media.phone} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const StepOptionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${gap("8px")}
  padding: 16px;
  border: 1px solid ${colors.c1};
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  min-width: 0;
  overflow: hidden;

  ${({active}) => active && `background: ${colors.c3};`}
  ${({hasImage}) => hasImage && `
    justify-content: normal;
  `}
  ${({disabled}) => disabled && `
    opacity: .5;
    pointer-events: none;
  `}


  ${media.mobile} {
    text-align: center;
    justify-content: center;
  }
`;
const StepOptionImage = styled(Image)`
  width: 50px;
  height: 50px;

  ${media.mobile} {
    display: none;
  }
`;
const StepOptionText = styled(withAttrs(Text, {as: "div"}))`
  font-family: ${fontFamily.secondary};
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
`;
const StepOptionDescription = styled(withAttrs(Text, {as: "div"}))`
  font-family: ${fontFamily.secondary};
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
`;
const StepsFooter = styled.div`
  display: flex;
`;
const StepsButton = styled(withAttrs(Button, {small: true}))`
  margin-left: auto;
`;
const StepFieldError = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: ${lineHeight};
  color: ${colors.r6};
`;
const PriceContainer = styled.div`
  display: none;
  top: 0;
  background: white;
  ${media.mobile} {
    display: block;
  }
`;
